/**
 * Module: registration
 *
 *
 */
const ui = require('./ui.js');
var utils = require( './utilities.js' );

/**
 * Initialize ui behaviors.
 */
function init() {
    const $sel = cacheSelectors();

    $sel.btn.$next.on('click', utils.debounce(authorizeUserRegistration));

    $sel.btn.$register.on('click', utils.debounce(registerUser));

    $sel.$form.on('keyup', utils.debounce((e) => {
        utils.form.handleSubmit(e, $sel.pane.$auth.is(':visible') ? authorizeUserRegistration : registerUser);
    }));

    $sel.btn.$back.on('click keyup', utils.debounce(toggleFormPane));

    $sel.input.$passwordToggle.on('click', () => {
        utils.form.togglePassword($sel.input.$fields)
    });

    $sel.input.$fields.on('focusin', function() {
        $(this).removeClass('error');
    }).on('focusout', function(e) {
        utils.form.validateInput(e, $(this), $sel.input.$fields);
    });

    $sel.input.$fields.filter('#password').on('keyup', (e, el) => {
        utils.form.validatePassword(e, el);
    });

    function toggleFormPane() {
        if ($sel.pane.$auth.is(':visible')) {
            $sel.pane.$auth.hide();
            $sel.pane.$user_info.css('display', 'flex');
        } else {
            $sel.pane.$auth.css('display', 'flex');
            $sel.pane.$user_info.hide();
        }
    }

    function authorizeUserRegistration() {
        let data = {};
        if (utils.form.prepareRequest($sel.input.$authFields, data) && !utils.form.isProcessing) {
            utils.form.isProcessing = true;
            ui.loader.show();
            const post = $.post('/wp-json/alterwood/v1/authorize_user_registration', data);
            post.done((res) => {
                if (res.status === 'error') {
                    $sel.input.$authFields.filter(res.input).addClass('error').after('<p class="input__message error">' + res.message + '</p>');
                } else {
                    if(res.is_supplier) {
                        $sel.input.$fields.filter('#is_provider').val('supplier');
                    }
                    for (const key of Object.keys(res.fields)) {
                        $sel.input.$fields.filter('#'+key).val(res.fields[key]);
                    }
                    if(!res.fields['last_name']) {
                        $sel.input.$names.hide();
                    }
                    toggleFormPane();
                }
                utils.form.isProcessing = false;
                ui.loader.hide();
            });
        }
    }

    function registerUser() {
        let data = {};
        if (utils.form.prepareRequest($sel.input.$fields, data) && !utils.form.isProcessing) {
            utils.form.isProcessing = true;
            ui.loader.show();
            const post = $.post('/wp-json/alterwood/v1/register_user', data);
            post.done((res) => {
                if (res.status === 'error') {
                    if(res.step === 'auth') {
                        toggleFormPane();
                        $sel.input.$authFields.filter(res.input).addClass('error').after('<p class="input__message error">' + res.message + '</p>');
                    } else {
                        $sel.input.$fields.filter(res.input).addClass('error').after('<p class="input__message error">' + res.message + '</p>');
                    }
                } else {
                    window.location.href = res.redirect;
                }
                utils.form.isProcessing = false;
                ui.loader.hide();
            });
        }
    }
}

function cacheSelectors() {
    let $sel = {
        '$form': $('.form--register')
    };
    $sel.btn = {
        '$next': $sel.$form.find('.next'),
        '$register': $sel.$form.find('.register'),
        '$back': $sel.$form.find('.back'),
    };
    $sel.pane = {
        '$auth': $sel.$form.find('#auth'),
        '$user_info': $sel.$form.find('#user_info'),
        '$passwordDialogue': $sel.$form.find('.dialogue--password'),
    };
    $sel.input = {
        '$fields': $sel.$form.find('.input'),
        '$authFields': $sel.pane.$auth.find('.input'),
        '$names': $sel.pane.$user_info.find('.-names'),
        '$passwordToggle': $sel.$form.find('.password--toggle'),
    };

    return $sel;
}

/**
 * Public API
 *
 * @type {Object}
 */
 module.exports = {
	init: init
};



// WEBPACK FOOTER //
// ./scripts/components/registration.js